//하나로 되어 있는 값은 상용과 테스트가 같음

//플레어레인 프로젝트키 //VITE_FLARELANE_PROJECT_KEY
export const flareLaneProjectKey = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' || envType === 'stage'
        ? 'd78a3f3b-6823-4190-9007-c716848009b1' // 상용키
        : 'b49bfe72-4bcf-4439-9cfd-cc3e32543402'; // 테스트키
};

//플레어레인 API키 //VITE_FLARELANE_API_KEY
export const flareLaneAPIKey = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' || envType === 'stage'
        ? 'Xtf3NAsIuxF0V1YUv9GJJ' // 상용키
        : 'g9YY4sbpEvvdrXvhE9hN1'; // 테스트키
};

//트레이스로그 USER_ID키 //VITE_TRACELOG_USER_ID
export const traceLogUserIdKey = (): string => {
    return 'S3cUr3YK3yWZthL0tsXOfATtobak_7Us';  
};

//트레이스로그 USER_ID_IV키 //VITE_TRACELOG_USER_ID_IV
export const traceLogUserIdIVKey = (): string => {
    return 'S3cUr3TtobakK3ye';  
};

//네이버 로그인 client_secret키 //VITE_NAVER_LOGIN_CLIENT_SECRET
export const naverLoginClientSecretKey = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' || envType === 'stage'
        ? 'TMK6EqGu51' // 상용키
        : 'e4v6hykZMh'; // 테스트키
};

//네이버 로그인 client_id키 //VITE_NAVER_LOGIN_CLIENT_ID
export const naverLoginClientIdKey = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' || envType === 'stage'
        ? 'HItK2Re6rk6OOWE4QeZi' // 상용키
        : 'bBOCY1VNTWHBpLsnfO77'; // 테스트키
};

//카카오 client_id키 //VITE_KAKAO_CLIENT_ID
export const kakaoClientIdKey = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' || envType === 'stage'
        ? 'c45f97076794a1248bf1a4c0f4501e36' // 상용키
        : 'edacedf48ec96352e5d31ffb8707c311'; // 테스트키
};


//카카오 dev키 //VITE_KAKAO_DEV_KEY
export const kakaoDevKey = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' || envType === 'stage'
        ? 'b3b6122271388863cd9eebe27089c073' // 상용키
        : '875911757dbb86981f7f551047fea401'; // 테스트키
};

//가비아 TrackingEvent (현재는 안쓰는듯함) //VITE_TRACKING_CODE
export const gabiaTrakingKey = (): string => {
    return '44292';  
};

//구글ADS CODE 1KEY //VITE_GOOGLE_ADS_CODE1
export const googleADSOneKey = (): string => {
    return 'AW-823375743';  
};

//구글ADS CODE 2KEY //VITE_GOOGLE_ADS_CODE2
export const googleADSTwoKey = (): string => {
    return 'AW-10841420946';  
};

//구글ADS CODE 3KEY //VITE_GOOGLE_ADS_CODE3
export const googleADSThreeKey = (): string => {
    return 'AW-11226165921';  
};

//앰플리튜드 API KEY //VITE_AMPLITUDE_API_KEY 
export const amplitudeAPIKey = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' 
        ? 'a8ba9fcc492cc64784d179933a76ec76' // 상용키
        : '485b184dfcc66685ea69e9d11973b9dd'; // 테스트키
};

//에어브릿지 TOKEN KEY //VITE_AIRBRIDGE_TOKEN 
export const airbridgeTokenKey = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' 
        ? '9445ab4b507d4c389d278d62b50b62f2' // 상용키
        : 'd7b7d8f7edc74ef2a41382fe284cb04e'; // 테스트키
};

//구글 애널리틱스 키 //VITE_G_ANALYTICE_MOBILE
export const googleAnalyticeKey = (): string => {
    return 'UA-90406440-1';  
};

//구글 애널리틱스 GA4 키 //VITE_G_ANALYTICE_MOBILE_GA4
export const googleAnalyticeGA4Key = (): string => {
    const config = useRuntimeConfig();
    const envType = config.public.VITE_ENV_TYPE;

    return envType === 'production' || envType === 'stage'
        ? 'G-BNNBGJXNRM' // 상용키
        : 'G-E8DS03K7HX'; // 테스트키
};

//와탭 nuxt key
export const whatapKey = (): string => {
    return 'x605a0g87bjp4-x7b2fd6ji5g96n-z1jc3q8mlf64pa';  
};